// PRC-018 · A7: entre el login y la aplicación (cargando, error y usuario sin cuenta de Pricing).
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useAuth } from '../../../context/AuthContext';
import { SimpleLayout } from '../components/JourneyLayouts';
import { StatusBlock } from '../components/JourneyBlocks';
import { JourneyButton } from '../components/JourneyBasics';
import { J } from '../journeyTokens';
import { SUPPORT_EMAIL } from '../journeyBilling';
import { isFirstAccess } from '../journeyAuth';
import AppSkeleton from '../components/AppSkeleton';

// PRC-025: la tarjeta de carga solo aparece si la carga tarda más de medio segundo.
const LOADING_DELAY_MS = 500;

const PricingEntryScreen: React.FC<{ mode: 'loading' | 'error' | 'missing' }> = ({ mode }) => {
  const { user, signOut, pricingContextError, reloadPricingContext } = useAuth();
  const userLabel = user?.email ?? null;
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    if (mode !== 'loading') return;
    const t = window.setTimeout(() => setShowLoading(true), LOADING_DELAY_MS);
    return () => window.clearTimeout(t);
  }, [mode]);

  // PRC-026: carga normal sin nada recordado → esqueleto de la app (sin datos).
  // La tarjeta queda para el primer acceso de una cuenta nueva (PRC-025).
  if (mode === 'loading' && !isFirstAccess()) return <AppSkeleton />;

  // Mientras tanto, solo el fondo: nunca la página privada.
  if (mode === 'loading' && !showLoading) {
    return <Box sx={{ minHeight: '100vh', bgcolor: J.bg }} />;
  }

  return (
    <SimpleLayout userLabel={userLabel} onSignOut={() => { void signOut(); }} narrow>
      {mode === 'loading' && (
        <StatusBlock
          variant="loading"
          minHeight={420}
          title="Cargando tu cuenta"
          text={isFirstAccess() ? 'Estamos activando tu prueba de 30 días.' : undefined}
        />
      )}
      {mode === 'error' && (
        <StatusBlock
          variant="error"
          minHeight={420}
          title="No hemos podido cargar tu cuenta"
          text="Puede ser un problema momentáneo de conexión o nuestro. Tus datos no se han perdido."
          actions={
            <>
              <JourneyButton onClick={() => reloadPricingContext()}>Reintentar</JourneyButton>
              <JourneyButton kind="ghost" onClick={() => { void signOut(); }}>Cerrar sesión</JourneyButton>
            </>
          }
          footnote={<>Si se repite, escríbenos a {SUPPORT_EMAIL} e indica este código: <b style={{ color: J.text }}>{pricingContextError ?? 'CTX-NET'}</b>.</>}
        />
      )}
      {mode === 'missing' && (
        <StatusBlock
          variant="info"
          minHeight={320}
          title="No tienes acceso a PROA Pricing"
          text="Tu usuario no pertenece a ninguna cuenta de PROA Pricing. Pide acceso al administrador de tu empresa."
          actions={<JourneyButton kind="ghost" onClick={() => { void signOut(); }}>Cerrar sesión</JourneyButton>}
        />
      )}
    </SimpleLayout>
  );
};

export default PricingEntryScreen;
